import { useEffect, useRef } from "react";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import Table from "@/components/Table/Table";
import useResponse from "@/shared/hooks/useResponse";
import { useDriverFilesTableStore } from "@/stores/useTableStore";

import LayoutWrapper from "../../../components/Layout/LayoutWrapper";
import DriversFilesPageHeaderActions from "../../../components/PageHeader/actions/pageHeaderActions/DriversFilesPageHeaderActions/DriversFilesPageHeaderActions";
import TabFilters from "../../../components/TabFilters/TabFilters";
import useDriverFilesInlineActions from "../../../components/Table/actions/inlineActions/hooks/useDriverFilesInlineActions";
import { ROUTES, TABLE_NAMES } from "../../../shared";
import { FILES_PAGE_TABS } from "../config";

const DriversFiles = () => {
  const { inlineActions } = useDriverFilesInlineActions();
  const { handleResponse } = useResponse();
  const { getData } = useAxiosPrivate();

  const { fetchData, resetInitialLoading, setIsCheckable, setInlineActions } =
    useDriverFilesTableStore();

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      resetInitialLoading();
      hasFetched.current = true;
      handlePageLoad();
    }
  }, []);

  const handlePageLoad = async () => {
    await fetchData(getData, handleResponse);
    setIsCheckable(true);
    setInlineActions(inlineActions);
  };

  return (
    <>
      <LayoutWrapper
        showDetailsSection={false}
        infoIconTooltip={"Files##files header info tooltip"}
        route={ROUTES.DriverFiles}
        tableName={TABLE_NAMES.Files}
      >
        <DriversFilesPageHeaderActions />
      </LayoutWrapper>

      <Table
        hasDetails={false}
        tabFilters={<TabFilters tabs={FILES_PAGE_TABS} />}
        hasTabFilters
        route={ROUTES.DriverFiles}
      />
    </>
  );
};

export default DriversFiles;
